var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 54,
    viewBox: "0 0 37 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exclusive-badge",
    filter: "url(#filter0_d_2271_89442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    opacity: 0.5,
    d: "M1 0L2 43V0H1Z",
    fill: "#18252D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 112",
    d: "M2 0H36V46C36 49.3137 33.3137 52 30 52H8C4.68629 52 2 49.3137 2 46V0Z",
    fill: "url(#paint0_linear_2271_89442)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 39",
    d: "M4 36.5C4 34.0147 6.06638 32 8.61538 32H29.3846C31.9336 32 34 34.0147 34 36.5V45.5C34 47.9853 31.9336 50 29.3846 50H8.61538C6.06638 50 4 47.9853 4 45.5V36.5Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("g", {
    id: "TOP"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0972 36.4997C15.1803 36.4997 15.2218 36.5412 15.2218 36.6243V37.4223C15.2218 37.5055 15.1803 37.547 15.0972 37.547H12.7032C12.6699 37.547 12.6533 37.5636 12.6533 37.5969V45.103C12.6533 45.1861 12.6117 45.2277 12.5286 45.2277H11.581C11.4979 45.2277 11.4563 45.1861 11.4563 45.103V37.5969C11.4563 37.5636 11.4397 37.547 11.4064 37.547H9.12469C9.04156 37.547 9 37.5055 9 37.4223V36.6243C9 36.5412 9.04156 36.4997 9.12469 36.4997H15.0972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0323 45.3399C18.4255 45.3399 17.8893 45.2152 17.4238 44.9658C16.9583 44.7165 16.5968 44.3673 16.3391 43.9185C16.0814 43.4613 15.9525 42.9376 15.9525 42.3474V39.3799C15.9525 38.7897 16.0814 38.2702 16.3391 37.8213C16.5968 37.3725 16.9583 37.0233 17.4238 36.774C17.8893 36.5246 18.4255 36.3999 19.0323 36.3999C19.6474 36.3999 20.1877 36.5246 20.6532 36.774C21.1187 37.0233 21.4803 37.3725 21.738 37.8213C21.9957 38.2702 22.1245 38.7897 22.1245 39.3799V42.3474C22.1245 42.9376 21.9957 43.4613 21.738 43.9185C21.4803 44.3673 21.1187 44.7165 20.6532 44.9658C20.1877 45.2152 19.6474 45.3399 19.0323 45.3399ZM19.0323 44.305C19.5975 44.305 20.0547 44.1304 20.4038 43.7813C20.753 43.4322 20.9275 42.9709 20.9275 42.3973V39.3674C20.9275 38.7856 20.753 38.3201 20.4038 37.9709C20.0547 37.6135 19.5975 37.4348 19.0323 37.4348C18.467 37.4348 18.0099 37.6135 17.6607 37.9709C17.3199 38.3201 17.1495 38.7856 17.1495 39.3674V42.3973C17.1495 42.9709 17.3199 43.4322 17.6607 43.7813C18.0099 44.1304 18.467 44.305 19.0323 44.305Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3547 36.4872C27.8618 36.4872 28.3065 36.5952 28.6889 36.8114C29.0796 37.0192 29.3788 37.3143 29.5866 37.6966C29.8027 38.079 29.9108 38.5196 29.9108 39.0183C29.9108 39.5171 29.8027 39.9535 29.5866 40.3275C29.3705 40.7016 29.0629 40.9925 28.6639 41.2003C28.2732 41.4081 27.8202 41.512 27.3049 41.512H25.1104C25.0771 41.512 25.0605 41.5287 25.0605 41.5619V45.103C25.0605 45.1861 25.0189 45.2277 24.9358 45.2277H23.9882C23.9051 45.2277 23.8635 45.1861 23.8635 45.103V36.6119C23.8635 36.5287 23.9051 36.4872 23.9882 36.4872H27.3547ZM27.1926 40.5395C27.6498 40.5395 28.0156 40.4023 28.2899 40.128C28.5725 39.8537 28.7138 39.4921 28.7138 39.0432C28.7138 38.5861 28.5725 38.2203 28.2899 37.946C28.0156 37.6634 27.6498 37.5221 27.1926 37.5221H25.1104C25.0771 37.5221 25.0605 37.5387 25.0605 37.572V40.4896C25.0605 40.5229 25.0771 40.5395 25.1104 40.5395H27.1926Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1373"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5084 8.04049C20.8408 8.12809 21.1192 8.35487 21.274 8.66327C21.8536 9.82367 22.2868 10.5281 22.7224 11.0993C23.164 11.6777 23.6296 12.1505 24.34 12.8597C25.9792 14.5001 26.8 16.6517 26.8 18.7997C26.8 20.9477 25.9792 23.0993 24.34 24.7397C21.0592 28.0193 15.7408 28.0193 12.46 24.7397C10.8208 23.0993 10 20.9477 10 18.7997C10 16.6517 10.8208 14.5001 12.46 12.8597C12.8032 12.5165 13.3192 12.4145 13.768 12.6005C14.2168 12.7853 14.5084 13.2233 14.5084 13.7081C14.5084 15.0521 14.5924 16.0757 14.986 16.8929C15.202 17.3417 15.5392 17.7809 16.12 18.1733C16.2592 16.9001 16.5136 15.3485 16.8568 13.8773C17.1268 12.7181 17.4628 11.5613 17.8636 10.5965C18.064 10.1129 18.2908 9.65447 18.5476 9.25727C18.7972 8.87087 19.1188 8.47853 19.534 8.20133C19.8208 8.01053 20.176 7.95169 20.5084 8.04049ZM20.9452 23.7449C19.54 25.1513 17.26 25.1513 15.8548 23.7449C15.1516 23.0429 14.8 22.1213 14.8 21.1997C14.8 21.1997 15.8548 21.7997 17.8 21.7997C17.8 20.5997 18.4 16.9997 19.3 16.3997C19.9 17.5997 20.2432 17.9513 20.9452 18.6545C21.6484 19.3565 22 20.2781 22 21.1997C22 22.1213 21.6484 23.0429 20.9452 23.7449Z",
    fill: "#18252D",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5084 7.04049C20.8408 7.12809 21.1192 7.35487 21.274 7.66327C21.8536 8.82367 22.2868 9.52811 22.7224 10.0993C23.164 10.6777 23.6296 11.1505 24.34 11.8597C25.9792 13.5001 26.8 15.6517 26.8 17.7997C26.8 19.9477 25.9792 22.0993 24.34 23.7397C21.0592 27.0193 15.7408 27.0193 12.46 23.7397C10.8208 22.0993 10 19.9477 10 17.7997C10 15.6517 10.8208 13.5001 12.46 11.8597C12.8032 11.5165 13.3192 11.4145 13.768 11.6005C14.2168 11.7853 14.5084 12.2233 14.5084 12.7081C14.5084 14.0521 14.5924 15.0757 14.986 15.8929C15.202 16.3417 15.5392 16.7809 16.12 17.1733C16.2592 15.9001 16.5136 14.3485 16.8568 12.8773C17.1268 11.7181 17.4628 10.5613 17.8636 9.5965C18.064 9.1129 18.2908 8.65447 18.5476 8.25727C18.7972 7.87087 19.1188 7.47853 19.534 7.20133C19.8208 7.01053 20.176 6.95169 20.5084 7.04049Z",
    fill: "url(#paint1_linear_2271_89442)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2271_89442",
    x: 0,
    y: 0,
    width: 37,
    height: 54,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2271_89442"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2271_89442",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2271_89442",
    x1: 30,
    y1: 4.07371e-7,
    x2: 15.577,
    y2: 36.4591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F953D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9AD53"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2271_89442",
    x1: 21.4278,
    y1: 7,
    x2: 15.9048,
    y2: 26.6754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FCFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopBadge);
export default __webpack_public_path__ + "static/media/top-badge.6cecd99e1c09f69c0348ef939952f0cd.svg";
export { ForwardRef as ReactComponent };